var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { faSpinner, faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { createRoot } from "react-dom/client";
import isEqual from "react-fast-compare";
import { getConfigVar } from "../../utils/Configuration";
import { EventManager } from "../../utils/EventManager";
import { addCheckClickOutside, checkKey, concatClassNames, createElementWithClass, filterChildrenOfType, trackOnElement } from "../../utils/Functions";
import { Tooltip } from "../layout/Tooltip";
import { BaseInput } from "./BaseInput";
import { Option } from "./Option";
var Combobox = /** @class */ (function (_super) {
    __extends(Combobox, _super);
    function Combobox(props) {
        var _this = _super.call(this, props, {
            show: false,
            searchValue: ""
        }) || this;
        _this.comboContainer = createElementWithClass("div", "dolfo-combobox-options");
        _this.componentDidMount = function () {
            addCheckClickOutside(_this.blurInput, _this, _this.comboContainer);
            _this.event = new EventManager("scroll", function (e) {
                var target = e.target;
                if (document.body.contains(target))
                    _this.prevTop = target.scrollTop;
            }, _this.comboContainer).register();
        };
        _this.componentWillUnmount = function () { return setTimeout(function () {
            var _a;
            (_a = _this.comboRoot) === null || _a === void 0 ? void 0 : _a.unmount();
            _this.comboContainer.remove();
            _this.event.unregister();
        }); };
        _this.componentDidUpdate = function (prevProps, prevState) {
            if (!isEqual(prevProps.defaultValue, _this.props.defaultValue) && _this.checkValueValidity(_this.props.defaultValue))
                _this.dispatchValue(_this.props.defaultValue, null, null, _this.props.defaultValue);
            if (prevState.show !== _this.state.show || !isEqual(prevState.value, _this.state.value) || prevState.searchValue !== _this.state.searchValue) {
                var _a = _this.state, show = _a.show, value_1 = _a.value, searchValue_1 = _a.searchValue, _b = _this.props, multiple_1 = _b.multiple, search_1 = _b.search;
                if (!show && _this.comboRoot) {
                    setTimeout(function () {
                        if (_this.comboRoot)
                            _this.comboRoot.unmount();
                        _this.comboContainer.remove();
                        _this.comboRoot = null;
                    });
                }
                else if (show) {
                    if (!_this.comboRoot)
                        _this.comboRoot = createRoot(_this.comboContainer);
                    var children = filterChildrenOfType(_this, Option).filter(function (opt) {
                        if (!search_1)
                            return true;
                        var val = search_1(opt.props.label);
                        return val.toLowerCase().indexOf(searchValue_1.toLowerCase()) >= 0;
                    });
                    _this.comboRoot.render(children.map(function (o, i) {
                        var option = new Option(o.props), optValue = o.props.value, selected = multiple_1 ? value_1.some(function (v) { return isEqual(v, optValue); }) : isEqual(value_1, optValue), valueToSend = multiple_1 ? selected ? value_1.filter(function (v) { return !isEqual(v, optValue); }) : value_1.concat(optValue) : selected ? null : optValue;
                        return React.createElement(React.Fragment, { key: i }, option.renderOption({
                            selected: selected,
                            type: "combo",
                            onClick: function () { return !multiple_1 && selected ? _this.setShowing(false) : _this.dispatchValue(valueToSend, null, null, valueToSend); },
                            onKey: function (e) { return _this.checkSpaceOrEnter(optValue, e); }
                        }));
                    }));
                    if (_this.searchInput)
                        setTimeout(function () { var _a; return (_a = _this.searchInput) === null || _a === void 0 ? void 0 : _a.focus(); });
                    document.body.appendChild(_this.comboContainer);
                    setTimeout(function () { return _this.comboContainer.scrollTo({ top: _this.prevTop }); });
                    trackOnElement(_this.comboContainer, _this, true, true, ".dolfo-input-label");
                }
            }
        };
        _this.checkSpaceOrEnter = function (value, e) {
            var _a = _this.props, disabled = _a.disabled, loading = _a.loading;
            checkKey(e, function () { return _this.dispatchValue(value, null, null, value); }, disabled || loading);
        };
        _this.checkValueValidity = function (value) {
            var children = filterChildrenOfType(_this, Option), multiple = _this.props.multiple;
            if (multiple)
                return Array.isArray(value) && value.every(function (v) { return children.some(function (c) { return isEqual(c.props.value, v); }); });
            return children.some(function (c) { return isEqual(c.props.value, value); });
        };
        _this.changeFilter = function (e) { return _this.setState({ searchValue: e.target.value }); };
        _this.onChange = function (e) {
            var _a = _this.props, disabled = _a.disabled, onChange = _a.onChange, multiple = _a.multiple, loading = _a.loading, nativeEvent = e.nativeEvent, value = nativeEvent.more, options = filterChildrenOfType(_this, Option).filter(function (c) { return !c.props.disabled; }), optionWithValue = options.find(function (opt) { return isEqual(opt.props.value, value); });
            if (disabled || loading)
                return;
            if (!multiple && !optionWithValue && value)
                return;
            if (multiple && !(value === null || value === void 0 ? void 0 : value.every(function (v) { return options.some(function (opt) { return isEqual(opt.props.value, v); }); })))
                return;
            _this.setState({ value: value, searchValue: "" }, function () {
                _this.setShowing(multiple ? _this.otherOptionsToSelect() : false);
                if (onChange)
                    onChange(value, e);
            });
        };
        _this.otherOptionsToSelect = function () {
            var children = filterChildrenOfType(_this, Option).filter(function (c) { return !c.props.disabled; }), value = _this.state.value;
            return children.some(function (c) { return !value.some(function (v) { return isEqual(v, c.props.value); }); });
        };
        _this.decodeValue = function () {
            var value = _this.state.value, multiple = _this.props.multiple, children = filterChildrenOfType(_this, Option);
            if (multiple) {
                var filteredC_1 = children.filter(function (c) { return value.some(function (v) { return isEqual(v, c.props.value); }); });
                return filteredC_1.map(function (v, i) {
                    var label = v.props.label;
                    if (i !== filteredC_1.length - 1 && filteredC_1.length > 1)
                        return React.createElement(React.Fragment, { key: i },
                            label,
                            ", ");
                    return React.createElement(React.Fragment, { key: i }, label);
                });
            }
            var child = children.find(function (c) { return isEqual(c.props.value, value); });
            return (child === null || child === void 0 ? void 0 : child.props.label) || "";
        };
        _this.setShowing = function (show) { return _this.setState({ show: show, searchValue: "" }); };
        _this.focusInput = function (e) {
            var _a = _this.props, disabled = _a.disabled, onFocus = _a.onFocus, loading = _a.loading;
            if (disabled || loading)
                return;
            _this.setShowing(true);
            if (onFocus)
                onFocus(e);
        };
        _this.blurInput = function (e) {
            var _a = _this.props, disabled = _a.disabled, loading = _a.loading, target = e.target;
            if (disabled || loading)
                return;
            if (_this.comboContainer.isEqualNode(target) || _this.comboContainer.contains(target))
                return;
            _this.setShowing(false);
        };
        _this.reset = function (e) {
            e.stopPropagation();
            var _a = _this.props, disabled = _a.disabled, multiple = _a.multiple, loading = _a.loading;
            if (disabled || loading)
                return;
            _this.dispatchValue(new Date().getTime(), null, null, multiple ? [] : null);
            setTimeout(function () { return _this.internalInput.focus(); });
        };
        _this.labelClick = function () { return _this.setShowing(false); };
        _this.render = function () {
            var _a = _this.props, required = _a.required, className = _a.className, style = _a.style, disabled = _a.disabled, onBlur = _a.onBlur, multiple = _a.multiple, loading = _a.loading, search = _a.search, _b = _this.state, value = _b.value, searchValue = _b.searchValue, show = _b.show;
            return React.createElement("div", { className: "dolfo-control", ref: function (r) { return _this.node = r; } },
                _this.getLabel(),
                React.createElement("div", { className: "dolfo-input-container" },
                    React.createElement("div", { className: concatClassNames([
                            "dolfo-combobox-input",
                            disabled || loading ? "disabled" : ""
                        ], className), style: style, onFocus: _this.focusInput, onBlur: onBlur, tabIndex: !disabled && !loading ? 0 : null, onKeyDown: function (e) {
                            if (e.code === "Tab")
                                _this.blurInput(new Event(e.type, e));
                        }, ref: function (r) { return _this.internalInput = r; } },
                        React.createElement("input", { ref: function (r) { return _this.input = r; }, className: "dolfo-input-text", type: "text", onChange: _this.onChange, value: _this.decodeValue().toString(), required: required, disabled: disabled || loading }),
                        search && show && React.createElement("input", { ref: function (r) { return _this.searchInput = r; }, className: "dolfo-input-text combobox-search", type: "text", onChange: _this.changeFilter, value: searchValue, disabled: disabled || loading, placeholder: getConfigVar("COMBOBOX_SEARCH") }),
                        React.createElement("div", { className: "dolfo-combobox-value" }, _this.decodeValue()),
                        loading && React.createElement("span", { className: "dolfo-spin-icon" },
                            React.createElement(FontAwesomeIcon, { icon: faSpinner, spin: true }))),
                    !disabled && !loading && ((!multiple && value) || (multiple && value.length > 0)) && React.createElement(Tooltip, { label: getConfigVar("RESET"), position: "left" },
                        React.createElement(FontAwesomeIcon, { icon: faXmark, className: "dolfo-input-reset", onClick: _this.reset }))));
        };
        _this.state = __assign(__assign({}, _this.state), { value: _this.checkValueValidity(props.defaultValue) ? props.defaultValue : props.multiple ? [] : null });
        return _this;
    }
    return Combobox;
}(BaseInput));
export { Combobox };
